import superagent from 'superagent';

export function Logged() {
  var val = window.sessionStorage.getItem("ID");
  if (!val || isNaN(val) || (val == 0)) {
    return false;
  } else {
    return true;
  }
}


export function LoggedUserId() {
  return window.sessionStorage.getItem("userID");
}

export function LoggedUserName() {
  return window.sessionStorage.getItem("userName");
}

export function LoggedUserEmail() {
  return window.sessionStorage.getItem("userEmail");
}

export function LoggedUserJazyk() {
  return window.sessionStorage.getItem("userJazyk");
}

export function LoggedUserOpravneni() {
  return window.sessionStorage.getItem("opravneni");
}

export function LoggedUserAdmin() {
  return window.sessionStorage.getItem("admin") == 'A';
}

export function LoggedUserLekce() {
  return window.sessionStorage.getItem("lekce");
}


export function Login(username, password) {
  superagent.post('https://rezervace.copasedeje.cz/servis/_users.php').send("user="+username).send("heslo="+password).then(res => {
    var myObject = JSON.parse(res.text);
    window.sessionStorage.setItem("ID", myObject.id);
    window.sessionStorage.setItem("userID", myObject.user_id);
    window.sessionStorage.setItem("userName", myObject.popis);
    window.sessionStorage.setItem("userEmail", myObject.email);
    window.sessionStorage.setItem("userJazyk", myObject.jazyk);
    window.sessionStorage.setItem("opravneni", myObject.opravneni);
    window.sessionStorage.setItem("admin", myObject.admin);
    window.sessionStorage.setItem("lekce", myObject.lekce);
 });
}


export function UserLogout() {
  window.sessionStorage.setItem("ID", '');
  window.sessionStorage.setItem("userID", '');
  window.sessionStorage.setItem("userName", '');
  window.sessionStorage.setItem("userEmail", '');
  window.sessionStorage.setItem("userJazyk", '');
  window.sessionStorage.setItem("opravneni", '');
  window.sessionStorage.setItem("admin", '');
  window.sessionStorage.setItem("lekce", '');
  //window.location.reload();
}



// WEBPACK FOOTER //
// src/components/login/Login.js